import React, { useState } from "react";
import WavesBackground from "@/components/WavesBackground/WavesBackground";
import cls from "./styles.module.scss";
import { EmailLoginForm } from "./EmailLoginForm";
import { EmailRegisterForm } from "./EmailRegisterForm";
import { TelegramWebLogin } from "./TelegramWebLogin";

type Mode = "login" | "register";

export function EmailAuthScreen() {
  const [mode, setMode] = useState<Mode>("login");
  // На экране «Проверьте почту» вход через Telegram не показываем — не отвлекает от кода
  const [codeStep, setCodeStep] = useState(false);

  return (
    <div className={cls.page}>
      <WavesBackground />
      <div className={cls.card}>
        <h1 className={cls.title}>БКоннект</h1>
        <p className={cls.subtitle}>
          {codeStep ? "Код из письма" : mode === "login" ? "Вход в аккаунт" : "Регистрация по email"}
        </p>

        {/* Аккаунт из Telegram — вход через подтверждение в мини-аппе */}
        {!codeStep ? (
          <>
            <TelegramWebLogin />
            <div className={cls.orDivider}>или по email</div>
          </>
        ) : null}

        {mode === "login" ? (
          <EmailLoginForm onSwitchToRegister={() => setMode("register")} onCodeStep={setCodeStep} />
        ) : (
          <EmailRegisterForm onSwitchToLogin={() => setMode("login")} onCodeStep={setCodeStep} />
        )}

        <p className={cls.footnote}>Мы не передаем ваши данные третьим лицам</p>
      </div>
    </div>
  );
}
